/**
 * AI assistant slide-over panel.
 *
 * A single store because the panel is rendered once in the footer but launched
 * from anywhere — front-page hero links and, via the `nav_menu_link_attributes`
 * filter, any nav menu item pointing at the assistant app.
 *
 * The scroll lock goes through the shared `scroll-lock` helper: one of those
 * launch points sits inside the mobile navigation overlay, which holds a lock
 * of its own, so clearing `body.style.overflow` here directly would unlock the
 * page while that menu is still open.
 */

import { lockScroll, unlockScroll } from './scroll-lock.js';

document.addEventListener( 'alpine:init', () => {

	Alpine.store( 'aiAssistant', {
		open: false,
		src : '',

		launch( url ) {
			// Changing an existing src reloads the iframe, which starts a new
			// conversation — only do that when a different starter is chosen.
			if ( url !== this.src ) {
				this.src = url;
			}
			this.open = true;
			lockScroll( 'aiAssistant' );
		},

		close() {
			this.open = false;
			unlockScroll( 'aiAssistant' );
		},
	});
});
